import React from "react"
// import HomeContainer from "../Container/HomeContainer";
import HomeContainer from "../Container/HomeContainer2"
import TeacherResume from "./TeacherResume.redux"

import Spinner from "../../Components/Spinner/Spinner"

//Yuan:redux
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
//Yuan-selector
import { selectUserDetails } from "../../redux/homePage/homePage.selectors"

const PreviewResume2 = ({ user }) => {
  if (user) {
    return (
      <HomeContainer
        user={user}
        isViewAsTeacher={false}
        footer={null}
        isShowWhereby={false}
        isShowPoliceCheckWwcc={true}
        tabResumeActive={true}
      >
        <TeacherResume
          user={user}
          isViewAsTeacher={false}
        />
      </HomeContainer>
    )
  }
  // else return <div>Loading</div>;
  else return <Spinner />
}

const mapStateToProps = createStructuredSelector({
  user: selectUserDetails,
})

export default connect(mapStateToProps)(PreviewResume2)
